import * as API from "./api";
import * as Types from "./Types";
import * as Constants from "../helpers/Constants";
import * as Strings from "./strings";

export function trySendErrorReportEmail(token, data, language, success, alert) {
  return dispatch => {
    dispatch({ type: Types.SEND_ERROR_REPORT_EMAIL });
    API.sendErrorReportEmail(token, data)
      .then(() => {
        success();

        dispatch({
          type: Types.SEND_ERROR_REPORT_EMAIL_SUCCESSFUL
        });
      })
      .catch(() => {
        dispatch({
          type: Types.SEND_ERROR_REPORT_EMAIL_FAILED
        });

        alert(
          Strings.default.INTERNAL_ERROR[language],
          Strings.default.INTERNAL_ERROR_INFO[language],
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK[language],
            onPress: () => {}
          }
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/ErrorReports.js